import React from 'react';


import './PaddleLikeSelect.css';


export interface OptionProps<T> {
    value: T;
    label: string | React.ReactNode;
}

export interface SelectProps<T extends string> {
    options: OptionProps<T>[];
    value: string;
    onChange: (newValue: T) => void;
    disabled?: boolean;
}


export const PaddleLikeSelect = <T extends string>(
    {
        options,
        value,
        onChange,
        disabled,
    }: SelectProps<T>
) => {
    return (
        <select className="PaddleLikeSelect body-large"
                onChange={(event) => {
                    onChange(event.target.value as T);
                }}
                value={value}
                disabled={disabled}
        >
            {
                options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))
            }
        </select>
    )
}
